import { loader } from 'graphql.macro'

export default function clientQuickbooksCustomer ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const schema = loader('./clientQuickbooksCustomer.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, {
    id: variables.id
  })
}
